<script lang="ts" setup>
import { useGlobalUser } from "@/stores/globalUser";
import { onClickOutside } from "@vueuse/core";
import { computed, ref } from "vue";

interface Option {
  label: string;
  value?: string | number;
  icon?: string;
  isNsfw?: boolean;
}

const props = withDefaults(
  defineProps<{
    options: Option[];
    selected: string | number;
    icon?: string;
    selectClass?: string;
    position?: "bottom" | "top";
  }>(),
  {
    selectClass:
      "btn-neutral  btn-xs lg:btn-sm rounded border border-base-content/10",
    position: "bottom",
  }
);

const emit = defineEmits<{
  (e: "update:selected", val?: string | number): void;
}>();

const user = useGlobalUser();
const selectRef = ref<HTMLElement | null>(null);
const currentItem = computed(
  () =>
    props.options.find((item) => item.value === props.selected) ??
    props.options[0]
);

onClickOutside(selectRef, () => {
  selectRef.value?.removeAttribute("open");
});

const onClickOption = (item: Option) => {
  if (item.isNsfw && (!user.user?.isAdult || !user.user?.isNsfwVisible)) {
    // Show age confirm dialog
    user.nsfwAgeConfirm.show = true;
    user.nsfwAgeConfirm.callback = () => {
      emit("update:selected", item.value);
      selectRef.value?.removeAttribute("open");
    };
  } else {
    emit("update:selected", item.value);
    selectRef.value?.removeAttribute("open");
  }
};
</script>

<template>
  <details
    ref="selectRef"
    :class="['dropdown dropdown-end shrink-0', `dropdown-${position}`]"
  >
    <summary :class="selectClass" class="btn">
      <i v-if="currentItem?.icon" :class="currentItem.icon" />
      {{ $t(currentItem.label) }}
      <i class="iconify mingcute--down-small-line" />
    </summary>
    <ul
      class="menu dropdown-content bg-base-100 rounded-box z-20 py-2 w-fit shadow text-xs lg:text-sm"
    >
      <li
        v-for="(item, idx) in options"
        :key="idx"
        @click="onClickOption(item)"
      >
        <a class="py-2 px-2">
          <i v-if="item.icon" :class="item.icon" />
          {{ $t(item.label) }}
        </a>
      </li>
    </ul>
  </details>
</template>
